{
  "name": "@crunchdao/coordinator-cli",
  "version": "4.0.0",
  "description": "CrunchDAO Coordinator Management CLI - Competition lifecycle management",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/crunchdao/crunchdao-protocol.git"
  },
  "publishConfig": {
    "access": "public"
  },
  "bin": {
    "crunch-coordinator": "./bin/crunch-coordinator"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "prepublishOnly": "npm run build"
  },
  "dependencies": {
    "@crunchdao/sdk": "^7.0.0",
    "@crunchdao/programs": "^7.0.0",
    "@crunchdao/shared-cli": "^1.1.13",
    "@coral-xyz/anchor": "^0.31.1",
    "chalk": "^4.1.2",
    "cli-table3": "^0.6.5",
    "bigint-buffer": "^1.1.5",
    "bs58": "^5.0.0"
  },
  "devDependencies": {
    "@types/node": "^20.0.0",
    "tsup": "^8.3.6",
    "typescript": "^5.0.0"
  },
  "files": [
    "dist/",
    "bin/"
  ],
  "keywords": [
    "crunchdao",
    "solana",
    "cli",
    "coordinator"
  ],
  "author": "CrunchDAO",
  "license": "MIT"
}
